module.exports = __webpack_public_path__ + "img/logo-rsp.9dc64a84.png";